import React, { useEffect, useState } from 'react';
import './Footer.css';
import { useLanguage } from '../context/LanguageContext';
import Logo from './Logo';
import Icon from './Icon';

const Footer = ({ setCurrentPage }) => {
  const { t, language } = useLanguage();
  const [visitCount, setVisitCount] = useState(0);

  useEffect(() => {
    const totalVisitsKey = 'websiteVisitCount';
    const sessionVisitKey = 'websiteVisitTracked';
    const hasTrackedThisSession = sessionStorage.getItem(sessionVisitKey);
    const savedCount = Number(localStorage.getItem(totalVisitsKey) || '0');

    if (!hasTrackedThisSession) {
      const nextCount = savedCount + 1;
      localStorage.setItem(totalVisitsKey, String(nextCount));
      sessionStorage.setItem(sessionVisitKey, 'true');
      setVisitCount(nextCount);
      return;
    }

    setVisitCount(savedCount);
  }, []);

  const handleNavClick = (pageId) => {
    setCurrentPage(pageId);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <div className="footer-logo-container" style={{ marginBottom: '20px' }}>
            <Logo variant="white" />
          </div>
          <p className="footer-description">
            {t('footer.description1')}
          </p>
          <p className="footer-description">
            {t('footer.description2')}
          </p>
        </div>

        <div className="footer-section">
          <h4>{t('footer.quickLinks')}</h4>
          <ul className="footer-links">
            <li><button onClick={() => handleNavClick('home')}>{t('nav.home')}</button></li>
            <li><button onClick={() => handleNavClick('about')}>{t('nav.about')}</button></li>
            <li><button onClick={() => handleNavClick('gallery')}>{t('nav.gallery')}</button></li>
            <li><button onClick={() => handleNavClick('events')}>{t('nav.events')}</button></li>
            <li><button onClick={() => handleNavClick('donation')}>{t('nav.donation')}</button></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>{t('footer.importantLinks')}</h4>
          <ul className="footer-links">
            <li><button onClick={() => handleNavClick('tenders')}>{t('nav.tenders')}</button></li>
            <li><button onClick={() => handleNavClick('committee')}>{t('nav.committee')}</button></li>
            <li><button onClick={() => handleNavClick('location')}>{t('nav.location')}</button></li>
            <li><button onClick={() => handleNavClick('aaras-download')}>{t('nav.download')}</button></li>
            <li><button onClick={() => handleNavClick('contact')}>{t('nav.contact')}</button></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>{t('footer.contact')}</h4>
          <div className="footer-contact">
            <p><Icon name="location" /> {t('footer.addressText')}</p>
            <p><Icon name="phone" /> +91 8275100238/8275100273</p>
            <p><Icon name="mail" /> koditnathmhaskoba63@gmail.com</p>
            <div className="footer-social">
              <button className="social-icon" aria-label="Facebook">
                <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                  <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"></path>
                </svg>
              </button>
              <button className="social-icon" aria-label="Instagram">
                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                  <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z"></path>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                </svg>
              </button>
              <button className="social-icon" aria-label="YouTube">
                <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                  <path d="M22.54 6.42a2.78 2.78 0 00-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 00-1.94 2A29 29 0 001 11.75a29 29 0 00.46 5.33A2.78 2.78 0 003.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 001.94-2 29 29 0 00.46-5.25 29 29 0 00-.46-5.33z"></path>
                  <polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"></polygon>
                </svg>
              </button>
              <button className="social-icon" aria-label="Twitter">
                <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                  <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-left">
          <p>{t('footer.copyright')}</p>
        </div>
        <div className="footer-visit-counter">
          <span className="footer-visit-label">{t('footer.visitCountLabel')}</span>
          <strong className="footer-visit-value">{visitCount.toLocaleString(language === 'mr' ? 'mr-IN' : 'en-IN')}</strong>
        </div>
        <div className="footer-bottom-right">
          <p>{t('footer.developedBy')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


